import axios from "axios";

/** Backend HTTP origin without trailing slash (rspack/dotenv injects API_URL). */
function backendOrigin(): string {
  return (process.env.API_URL ?? "http://localhost:3000").replace(/\/$/, "");
}

/** OpenAPI docs (Swagger UI), i.e. `${API_URL}/api/docs`. */
export function getApiDocsHref(): string {
  return `${backendOrigin()}/api/docs`;
}

function apiBaseUrl(): string {
  return `${backendOrigin()}/api`;
}

const http = axios.create({
  baseURL: apiBaseUrl(),
});

export const api = {
  getAlliances: async (params: Record<string, any>) => {
    const { data } = await http.get("/alliances", { params });
    return data;
  },

  getAllianceById: async (id: string) => {
    const { data } = await http.get(`/alliances/${id}`);
    return data;
  },

  getAllianceBySport: async (sport: string, name?: string) => {
    const { data } = await http.get(
      `/alliances/sport/${encodeURIComponent(sport)}`,
      name !== undefined && name.trim() !== ""
        ? { params: { name: name.trim() } }
        : {},
    );
    return data;
  },

  getStats: async () => {
    const { data } = await http.get("/alliances/stats");
    return data;
  },

  getCoverage: async () => {
    const { data } = await http.get("/alliances/coverage");
    return data;
  },

  getErrorsSummary: async () => {
    const { data } = await http.get("/errors/summary");
    return data;
  },

  getErrors: async (params: Record<string, unknown>) => {
    const { data } = await http.get("/errors", { params });
    return data;
  },

  getErrorById: async (id: string) => {
    const { data } = await http.get(`/errors/${id}`);
    return data;
  },

  getApiUptime: async () => {
    const { data } = await http.get("/uptime");
    return data;
  },

  getAllianceUptimeList: async () => {
    const { data } = await http.get("/uptime/alliances");
    return data;
  },
};
